import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { toast } from "sonner";
import api, { errorMessage } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function ChangePasswordModal({ open, forced, onClose }) {
  const { refresh } = useAuth();
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nova.length < 6) return toast.error("Mínimo 6 caracteres");
    if (nova !== confirmar) return toast.error("Senhas não conferem");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { senha_atual: atual, nova_senha: nova });
      toast.success("Senha trocada");
      setAtual(""); setNova(""); setConfirmar("");
      await refresh();
      onClose && onClose();
    } catch (e) { toast.error(errorMessage(e, "Erro")); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !forced && !saving) onClose && onClose(); }}>
      <DialogContent className={`max-w-sm ${forced ? "[&>button:last-child]:hidden" : ""}`} data-testid="change-password-modal">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold">
            {forced ? "Troque sua senha para continuar" : "Trocar senha"}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label className="text-xs">Senha atual</Label>
            <Input data-testid="cp-atual" type="password" value={atual} onChange={(e)=>setAtual(e.target.value)} required className="h-9 text-sm" /></div>
          <div><Label className="text-xs">Nova senha (mínimo 6)</Label>
            <Input data-testid="cp-nova" type="password" value={nova} onChange={(e)=>setNova(e.target.value)} required className="h-9 text-sm" /></div>
          <div><Label className="text-xs">Confirmar</Label>
            <Input data-testid="cp-confirm" type="password" value={confirmar} onChange={(e)=>setConfirmar(e.target.value)} required className="h-9 text-sm" /></div>
          <Button data-testid="cp-submit" type="submit" disabled={saving} className="w-full bg-[#1b4332] hover:bg-[#143326] text-white h-9 text-sm font-semibold">
            {saving ? "Salvando..." : "Trocar senha"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
